import React from 'react';
import './BylawsPage.css';

const ARTICLES = [
  { num: 1, title: 'Derneğin Adı ve Merkezi', body: 'Derneğin adı "Türkiye Kalite Mühendisleri Derneği"dir. Kısa adı TKMD olup kurumsal kullanımda TKMB (Türkiye Kalite Mühendisleri Birliği) markası kullanılabilir. Derneğin merkezi Kocaeli ilindedir. Dernek gerekli görülen yerlerde şube ve temsilcilik açabilir.' },
  { num: 2, title: 'Derneğin Amacı', body: 'Kalite mühendisliği mesleğinin gelişimini desteklemek, kalite yönetimi uygulamalarının yaygınlaşmasına katkı sağlamak, meslek mensupları arasında koordinasyonu güçlendirmek, mesleki standartların oluşumuna katkıda bulunmak ve kalite kültürünün sanayi ve hizmet sektörlerinde kurumsallaşmasını sağlamaktır.' },
  { num: 3, title: 'Faaliyet Konuları', body: 'Kalite mühendisliği meslek standartları geliştirmek, mesleki etik ilkeler belirlemek, eğitim ve seminerler düzenlemek, mesleki sicil ve yetkinlik sistemi oluşturmak, sanayi ve OSB\'ler ile iş birliği kurmak, sektörel rapor ve teknik görüşler hazırlamak.' },
  { num: 4, title: 'Üyelik Türleri', body: 'Asil, aday, kurumsal ve onursal üyelik türleri bulunmaktadır.' },
  { num: 5, title: 'Üyelik Şartları', body: '18 yaşını doldurmuş olmak, kalite mühendisliği veya ilgili alanlarda faaliyet göstermek, tüzüğü kabul etmek ve başvurunun yönetim kurulunca onaylanması gerekir.' },
  { num: 6, title: 'Üyelik Başvurusu', body: 'Üyelik başvuruları yazılı veya elektronik olarak yapılır ve yönetim kurulu 30 gün içinde karara bağlar.' },
  { num: 7, title: 'Üyelikten Ayrılma ve Çıkarılma', body: 'Üyeler yazılı bildirim ile ayrılabilir. Dernek ilkelerine aykırı davranan üyeler yönetim kurulu kararı ile çıkarılabilir.' },
  { num: 8, title: 'Dernek Organları', body: 'Genel kurul, yönetim kurulu ve denetim kuruludur.' },
  { num: 9, title: 'Genel Kurul', body: 'En yetkili organdır ve iki yılda bir toplanır.' },
  { num: 10, title: 'Yönetim Kurulu', body: '5 asil ve 5 yedek üyeden oluşur ve derneği temsil eder.' },
  { num: 11, title: 'Denetim Kurulu', body: '3 asil ve 3 yedek üyeden oluşur ve mali/idari denetim yapar.' },
  { num: 12, title: 'Gelir Kaynakları', body: 'Üyelik aidatları, bağışlar, eğitim gelirleri, yayın ve proje gelirleri, sponsorluklar.' },
  { num: 13, title: 'Aidat', body: 'Giriş ve yıllık aidatlar genel kurulca belirlenir.' },
  { num: 14, title: 'Şube Açma', body: 'Türkiye genelinde şube ve temsilcilik açılabilir.' },
  { num: 15, title: 'Mesleki Çalışmalar', body: 'Meslek standartları, teknik rehberler ve gelişim programları hazırlanabilir.' },
  { num: 16, title: 'Tüzük Değişikliği', body: 'Genel kurulun 2/3 çoğunluğu ile yapılır.' },
  { num: 17, title: 'Fesih', body: 'Genel kurul kararı ile yapılır.' },
  { num: 18, title: 'Hüküm Bulunmayan Haller', body: 'İlgili mevzuat hükümleri uygulanır.' },
];

const BylawsPage = () => {
  return (
    <div className="bylaws-page page-wrapper">
      <div className="page-hero">
        <div className="container">
          <h1 className="page-hero-title">Türkiye Kalite Mühendisleri Derneği Tüzüğü</h1>
          <p className="page-hero-subtitle">TKMB – Türkiye Kalite Mühendisleri Birliği</p>
        </div>
      </div>

      <div className="page-content">
        <div className="container">
          <section className="content-section intro-block">
            <p>
              Aşağıda Türkiye Kalite Mühendisleri Derneği (TKMB) tüzüğünün tam metni yer almaktadır.
            </p>
          </section>

          <section className="content-section">
            <ol className="bylaws-list">
              {ARTICLES.map((art) => (
                <li key={art.num} className="bylaws-article">
                  <h2 className="bylaws-article-title">
                    <span className="bylaws-article-num">Madde {art.num}</span>
                    {' – '}
                    {art.title}
                  </h2>
                  <p className="bylaws-article-body">{art.body}</p>
                </li>
              ))}
            </ol>
          </section>

          <p className="contact-cta">
            Tüzük ve yönetmelikler hakkında bilgi almak için{' '}
            <a href="mailto:info@tkmb.org">info@tkmb.org</a> adresinden iletişime geçebilirsiniz.
          </p>
        </div>
      </div>
    </div>
  );
};

export default BylawsPage;
